export function hubMapViewForRadius (radiusMeters, longitude, latitude) {
  const zoom = Number(radiusMeters) === 200 ? 16 : 17

  return {
    center: [Number(longitude), Number(latitude)],
    zoom
  }
}
